import { questions } from 'site-modules/shared/components/incentives/incentives-wizard/questions/questions';
import { QUESTION } from 'site-modules/shared/components/incentives/incentives-wizard/constants/question-variants';

export function shouldShowBackButton(id, flowSteps) {
  return flowSteps.filter(flowStep => questions[flowStep].variant === QUESTION).findIndex(stepId => stepId === id) > 0;
}
